import { useEffect } from "react";
import SaintsSearchList from "../components/SaintsSearchList";

export default function Search() {
  useEffect(() => {
    document.title = "Dulia: Search";
  }, []);

  return <SaintsSearchList title="Search" showAdminActions showNewButton />;
}
